/** @module SiteAdmin/DocumentProperties **/
define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"csi/html",
	"csi/locale",
	"csi/xml",

	"./DocumentImageRemove"
], function(declare, Widget, html, locale, xml) {

	return declare(Widget, {
		imagePlugins: ['image', 'imageDefault', 'imageLeft', 'imageRight', 'documentImageRemove', 'imageLabel'],
		plugins: ['print', 'pdf', 'attributes', 'image', 'imageDefault', 'imageLeft', 'imageRight', 'documentImageRemove', 'imageLabel', 'refresh'],

		/** @property {View} proofingStatusView - ProofingStatus view */
		proofingStatusView: null,

		/** @property {View} proofProgressView - ProofProgress view */
		proofProgressView: null,

		/** destroy both views */
		_destoryViews() {
			this.proofProgressView?.destroyView();
			this.proofingStatusView?.destroyView();
		},

		/**
		 * insert proof progress view if proofing is available and proof is started
		 * @override
		 */
		_postViewDeferred: function(ctx, dfds) {
			const viewNode = this.getViewNode();
			if (!viewNode) {
				return;
			}

			const proofNodeCNL = viewNode.ProofWorkflow;

			// exit if proof is not started or not avaialble
			if (xml.isEmptyURL(proofNodeCNL)) {
				return;
			}

			const cache = this.cacheView;
			// resolve dependencies
			cache.getNodeDependencies([proofNodeCNL], [
				"Child:Subprocesses/Child:Tasks",
			]).then(() => {
				const proofNode = cache.getNode(proofNodeCNL);
				if (!proofNode) {
					return;
				}

				this._destoryViews();
				html.setVisible(this.actionsNode, false);

				// create containing div and title
				const title = html.create("div", {"class": "csi-view-title", innerText: locale.resource("PopupProofProgress_Title")});
				const div = this.getExtraPropertyDiv("csi-proof-progress", title);

				dfds.push(this._insertAndCreateView("ProofingStatus", viewNode, div).then((view) => {
					this.proofingStatusView = view;
				}));

				// create and insert proof progress view
				dfds.push(this._insertAndCreateView("ProofProgress", proofNode, div).then((view) => {
					this.proofProgressView = view;
					html.setVisible(this.actionsNode, true);
				}));
			})
		}
	});
});